// extracted by mini-css-extract-plugin
export default {"demoEnd":"TourEnd_demoEnd__vClOF"};